module.exports = __webpack_public_path__ + "img/submit.5e63de0e.svg";